export default (https) => ({
  async getList(params = []) {
    const queryString = params
      .filter(p => p.value !== null && p.value !== undefined && p.value !== '')
      .map(p => `${encodeURIComponent(p.key)}=${encodeURIComponent(p.value)}`)
      .join('&');
    const response = await https.get(`/parts?${queryString}`);
    return response.data;
  },

  async add(payload) {
    if (payload instanceof FormData) {
      const response = await https.post('/parts', payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    }
    const response = await https.post('/parts', payload);
    return response.data;
  },

  async update(id, payload) {
    if (payload instanceof FormData) {
      const response = await https.post(`/parts/${id}`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    }
    const response = await https.post(`/parts/${id}`, payload);
    return response.data;
  },

  async deleteById(id) {
    const response = await https.delete(`/parts/${id}`);
    return response.data;
  },

  // Single part (with supplier, image, attachments)
  async show(id) {
    const response = await https.get(`/parts/${id}`);
    return response.data;
  },

  // Excel/CSV import for a given sub_type
  async import(file, subType) {
    const formData = new FormData();
    formData.append('excel_file', file);
    formData.append('sub_type', subType);
    const response = await https.post('/parts/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Finished goods that use this part
  async linkedProducts(id) {
    const response = await https.get(`/parts/${id}/linked-products`);
    return response.data;
  },

  // Link a finished good to this part
  async linkProduct(id, payload) {
    const response = await https.post(`/parts/${id}/linked-products`, payload);
    return response.data;
  },

  // Unlink a finished good from this part
  async unlinkProduct(id, productId) {
    const response = await https.delete(`/parts/${id}/linked-products/${productId}`);
    return response.data;
  },
});
